import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import moment from 'moment';

const Footer = () => {
    return (
        <Paper style={{textAlign: "center", backgroundColor: "black", color: "white"}}>
            <Typography variant="caption">
                Instituto de Seguridad Social del Estado de Tabasco <br/>
                Infoisset - Portal de Información para derechohabientes <br/>
                Gobierno del Estado de Tabasco &copy; Derechos Reservados 2013 - {moment().year()}
            </Typography>
        </Paper>
    );
};

export default Footer;